import styled from '@emotion/styled';
import { css } from '@emotion/core';

import { layers } from 'app/spacing';
import DraggableItem from 'components/Kizen/DraggableItem';
import { itemVerticalMargin } from '../Dropzone';

export const StyledDraggableItemWrapper = styled.div`
  display: flex;
  width: 100%;
  margin: ${itemVerticalMargin}px 0;

  ${({ bringToTop, forceToTop }) =>
    (bringToTop || forceToTop) &&
    css`
      z-index: ${layers.content(0, 1)};
    `}
`;

export const StyledDraggableItem = styled(DraggableItem)`
  flex-grow: 1;
  flex-wrap: nowrap;
  min-width: 0;
  ${({ compact }) =>
    compact
      ? css`
          padding: 7px 10px 6px 10px;
        `
      : ''}

  background: var(--color-background-white);
  ${({ redBorder }) =>
    redBorder
      ? css`
          border: 1px solid var(--color-button-warning-hover);
        `
      : ''}

  && > i + * {
    // fix content height
    max-height: 20px;

    input {
      padding-top: 0;
      padding-left: 0;
      position: relative;
      top: -1px;
    }
  }

  && > i {
    cursor: grab;
  }

  &&:hover > i svg {
    color: var(--color-background-dark);
  }

  && > i:hover svg {
    color: var(--color-background-darker);
  }

  ${({ darken }) =>
    darken
      ? css`
          background-color: var(--color-background-light);
        `
      : null}

  ${({ disabled }) =>
    disabled
      ? css`
          && > i.ToolbarDragHandle,
          &&:hover > i.ToolbarDragHandle,
          && > i.ToolbarDragHandle:hover {
            cursor: default;
            svg {
              color: var(--color-background-medium) !important;
            }
          }
          && > i {
            cursor: default;
          }
        `
      : null}
  ${({ isHidden, hideDragger }) =>
    (isHidden || hideDragger) &&
    css`
      background-color: var(--color-background-light);

      && > i,
      &&:hover > i,
      && > i:hover {
        cursor: default;
        svg {
          ${hideDragger ? 'display: none;' : ''}
          color: var(--color-border-medium);
        }
      }
    `}
`;
